module.exports = __webpack_public_path__ + "img/vri-light.23eb641c.svg";